/* @flow */

import React, { Component } from 'react';
import glamorous from 'glamorous';
import { map } from 'lodash/fp';
import GroupCard from 'app/components/friends/groups/GroupCard';
import Card from 'app/components/commons/Card';
import GroupDetails from 'app/components/friends/groups/GroupDetails';
import CarouselPaginationDesktop from 'app/components/friends/common/CarouselPaginationDesktop';
import PaginationManager from 'app/components/friends/common/PaginationManager';
import { NEW_GROUP_ID } from 'app/constants/friendConstants';
import t from 'app/utils/translate';

const mapIds = map('id');

type Props = {
  onCardClick?: (number | string) => void,
  currentGroupId?: number | string,
  groups?: Array<FriendGroup>,
};

const ClosedCard = glamorous.div({
  borderRadius: 8,
  flexBasis: 'calc(20% + 4px)',
  flexGrow: 0,
  flexShrink: 0,
  height: 110,
});

class GroupCardsDesktopClosed extends Component<Props> {
  props: Props;

  static defaultProps = {
    groups: [],
    currentGroupId: undefined,
    onCardClick: undefined,
    open: false,
  };

  render() {
    const {
      currentGroupId,
      groups = GroupCardsDesktopClosed.defaultProps.groups,
      onCardClick,
    } = this.props;

    return (
      <PaginationManager
        itemIds={mapIds(groups)}
        currentItemId={currentGroupId}
      >
        <CarouselPaginationDesktop>
          {groups.length > 0 ? (
            groups.map(group => (
              <ClosedCard key={group.id}>
                <GroupCard group={group} onClick={onCardClick} />
              </ClosedCard>
            ))
          ) : (
            <ClosedCard>
              <Card link={`/groups/${NEW_GROUP_ID}`}>
                <GroupDetails name={t('your group')} temporary />
              </Card>
            </ClosedCard>
          )}
        </CarouselPaginationDesktop>
      </PaginationManager>
    );
  }
}

export default GroupCardsDesktopClosed;
